module.exports = "tr.list { \n    height: auto;\n}\ntd { \n    width: 33%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/latest-offers/latest-offers.component.css
// module id = ./src/app/latest-offers/latest-offers.component.css
// module chunks = main